// extracted by mini-css-extract-plugin
module.exports = {"className":"ar-SA_className__J_hd9"};